<template lang="pug">
  .component-client-registration
    form(v-on:keyUp='driverLicenseUpdated')
      .row
        h2 Document
      .row
        .columns
          label Document Type  &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            selectize-document-type(@optionSelected="selectDocumentType")
      .document-fields(v-if="documentType")
        .row
          .small-12.large-2.columns(v-if="documentType.has_expiry")
            label Expiry  &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              date-picker(v-model='document.expiry_date')
          .small-12.large-2.columns(v-if="documentType.has_emission")
            label Issue date  &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              date-picker(v-model='document.issue_date')
          .small-12.large-6.columns(v-if="documentType.has_number")
            label Number  &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              input(type='text', placeholder='', v-model='document.number' required)
        .row
          .small-12.large-6.columns(v-if="documentType.has_issuer")
            label Issued by  &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              input(type='text', placeholder='', v-model='document.issuer' required)
          .small-12.large-6.columns(v-if="documentType.has_country")
            label Issue country  &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              selectize-country(@optionSelected="selectLicenseCountry")
        .row
          .columns
            .upload(v-for="(attachment,index) in documentType.attachment_views")
              label Upload {{attachment}} &nbsp;
                tooltip(:open="true", :position="'right'", :tip="'Document Upload Required'")
                  span.fa.fa-star
              dropzone(:id="'#myVueDropzone'+index", :url='dropzoneUrl', @vdropzone-success='(file, response)=>{uploaded(file,response, attachment)}')
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import DatePicker from '../../components/structure/DatePicker'
  import Dropzone from 'components/structure/Dropzone'
  import SelectizeCountry from '../../components/structure/ui/lists/selectize/SelectizeCountry'
  import SelectizeDriverLicense from '../../components/structure/ui/lists/selectize/SelectizeDriverLicense'
  import SelectizeDocumentType from '../../components/structure/ui/lists/selectize/SelectizeDocumentType'
  import Tooltip from 'components/structure/foundation/Tooltip'

  export default {
    name: 'BackofficeDriverLicenseCreate',
    components: {
      SelectizeDocumentType,
      SelectizeDriverLicense,
      SelectizeCountry,
      DatePicker,
      Dropzone,
      Tooltip
    },
    data() {
      return {
        documentType: null,
        dropzoneUrl: KeplerBackofficeSdk.getUrlForDropzone(),

        document: {
          document_type_id: null,
          expiry_date: null,
          issuer: null,
          issuer_country: null,
          issue_date: null,
          number: null,
          attachments: {},
        }

      }
    },
    computed: {},
    mounted() {

    },
    created() {
      this.dropzoneUrl = KeplerBackofficeSdk.getUrlForDropzone()
    },
    methods: {
      selectLicenseCountry(country) {
        this.document.issuer_country = country.name
        this.driverLicenseUpdated()
      },
      selectDocumentType(document) {
        this.document.document_type_id = document.id
        this.documentType = document
        this.driverLicenseUpdated()
      },
      uploaded: function (file, response, view) {
        this.document.attachments[view] = response.token
        this.driverLicenseUpdated()
      },
      driverLicenseUpdated() {
        this.$emit('driverLicenseUpdated', this.document)
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateDriverLicense.vue?46cae1bd